//import mapboxgl from 'mapbox-gl';
//import mapboxSdk from '@mapbox/mapbox-sdk';
//import mapboxDirections from '@mapbox/mapbox-sdk/services/directions';
//
//import { CreateMap, InitMapboxStyleSwitch } from 'SrcJS/maps/mapbox-custom';
import { LazyInitializer } from 'Utils/LazyInitializer';

var map;
var myLngLat;
var poiMarker;
var markerWidth = 35, markerHeight = 47;

function hasMapContainer() {
    let result = (document.querySelector('#map_canvas_hotel_hotel') != null);
    console.log('>>> hasMapContainer: ' + result);
    return result;
}
var hasMapDependencies = hasMapContainer();
var mapboxgl = undefined;
var mapboxSdk = undefined;
var mapboxDirections = undefined;
var CreateMap = undefined;
var InitMapboxStyleSwitch = undefined;

async function getComponents() {
    /* Dynamic Imports: https://webpack.js.org/guides/code-splitting/#dynamic-imports
     * The reason we need default is that since webpack 4, when importing a CommonJS module, 
     * the import will no longer resolve to the value of module.exports, 
     * it will instead create an artificial namespace object for the CommonJS module.
     * For more information on the reason behind this, read webpack 4: import() and CommonJs.
     * https://medium.com/webpack/webpack-4-import-and-commonjs-d619d626b655
    */
    const mapboxgl = await import('mapbox-gl');
    const { default: mapboxSdk } = await import('@mapbox/mapbox-sdk'); // Target: transpiled-ESM (__esModule)
    const { default: mapboxDirections } = await import('@mapbox/mapbox-sdk/services/directions'); // Target: transpiled-ESM (__esModule)
    const { CreateMap, InitMapboxStyleSwitch } = await import('SrcJS/maps/mapbox-custom');

    return {
        mapboxgl,
        mapboxSdk,
        mapboxDirections,
        CreateMap, InitMapboxStyleSwitch
    }
}


function createMarker(markerLngLat, iconUrl, popupContent) {
    var marker = null;

    if (!markerLngLat)
        return marker;

    if (iconUrl && iconUrl != "") {
        // create a DOM element for the marker
        var el = document.createElement('img');
        el.src = iconUrl;
        el.className = 'marker';
        marker = new mapboxgl.Marker({ element: el, anchor: 'bottom' });
    } else {
        marker = new mapboxgl.Marker({ color: '#3FB1CE' });
    }
    marker.setLngLat(markerLngLat);

    if (popupContent && popupContent != "") {
        // create the popup
        var popup = new mapboxgl.Popup({
            //offset: [0, 0],
            //anchor: 'top-left',
            //className: 'marker-popup',
            closeOnClick: false,
        }).setHTML(popupContent);
        // sets a popup on this marker
        marker.setPopup(popup);
    }

    // add marker to map
    marker.addTo(map);
    return marker;
}

function initialize() {
    var bounds = new mapboxgl.LngLatBounds();

    var options = {
        container: 'map_canvas_hotel_hotel', // HTML container id
        style: AppData.Mapbox.Style, //'mapbox://styles/mapbox/streets-v11', // style URL
        //center: [0.0, 39.0], // starting position as [lng, lat]
        //zoom: 5,
        scrollZoom: false,
        //pitchWithRotate: true,
        //touchZoomRotate: false
    };
    map = CreateMap(options);
    global.map = map;
    map.on("load", function () {
        InitMapboxStyleSwitch(map);
    });

    //directionsDisplay = new google.maps.DirectionsRenderer({suppressMarkers: true});
    //directionsService = new google.maps.DirectionsService();
    //directionsDisplay.setMap(map);

    // Markers
    myLngLat = new mapboxgl.LngLat(AppData.HotelMapbox.txtLongitude, AppData.HotelMapbox.txtLatitude);

    bounds.extend(myLngLat);

    //map.setZoom(10);
    //map.setCenter(myLngLat);
    map.easeTo({
        center: myLngLat,
        zoom: 10
    });

    var beachMarker = createMarker(myLngLat, AppData.HotelMapbox.beachMarkerImg);
}
function map_trigger() {
    map.resize();
    var myLngLat = new mapboxgl.LngLat(AppData.HotelMapbox.txtLongitude, AppData.HotelMapbox.txtLatitude);
    //map.setZoom(10);
    //map.setCenter(myLngLat);
    map.jumpTo({
        center: myLngLat,
        zoom: 10
    });
}










var defaultStart = [AppData.HotelMapbox.txtLongitude, AppData.HotelMapbox.txtLatitude];

function initializeDirections() {
    // More deatils here https://github.com/mapbox/mapbox-sdk-js/blob/master/docs/services.md#directions
    // Example here https://docs.mapbox.com/help/tutorials/getting-started-directions-api/
    var mapboxClient = mapboxSdk({ accessToken: AppData.Mapbox.AccessToken });
    //var directionsClient = mapboxClient.directions;
    var directionsClient = mapboxDirections(mapboxClient);

    // initialize the map canvas to interact with later
    var canvas = map.getCanvasContainer();

    var start = defaultStart;
    // create a function to make a directions request
    function getRoute(end, travelMode) {
        // make directions request using cycling profile
        // an arbitrary start will always be the same
        // only the end or destination will change
        var start = defaultStart;

        var req = directionsClient.getDirections({
            profile: travelMode, // "driving-traffic" | "driving" | "walking" | "cycling" (optional, default "driving")
            waypoints: [{
                coordinates: start,
                //approach: 'unrestricted'
            }, {
                coordinates: end
            }
            ],
            geometries: "geojson",
            roundaboutExits: true,
            steps: true
        });
        req.send().then(response => {
            var flgUpdated = false;
            if (response && response.body) {
                flgUpdated = updateRouteDirections(response.body);
            }
            if (!flgUpdated) {
                //clean up 'route' source if smth went wrong
                updateRouteSource([]);
            }
        });
    };

    function updateRouteDirections(response) {
        let result = false;
        if (!map) {
            console.log('updateRouteDirections: Nofound map!');
            return result;
        }
        if (!response)
            return result;
        if (!response.code || response.code == '' || response.code.toLowerCase() != "ok") {
            console.log('updateRouteDirections: Invalid responce.code');
            return result;
        }

        if (!response.routes || response.routes.length < 1) {
            console.log('updateRouteDirections: Nofound routes');
            return result;
        }

        var data = response.routes[0];
        var route = data.geometry.coordinates;
        updateRouteSource(route);
        result = true;
        return result;
    };

    function updateRouteSource(route) {
        var geojson = {
            "type": "Feature",
            "properties": {},
            "geometry": {
                "type": "LineString",
                "coordinates": route
            }
        };

        if (map.getSource('route')) {
            // if the route already exists on the map, we'll reset it using setData
            map.getSource('route').setData(geojson);
        } else {
            // otherwise, we'll make a new request
            map.addLayer({
                "id": "route",
                "type": "line",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "Feature",
                        "properties": {},
                        "geometry": {
                            "type": "LineString",
                            "coordinates": geojson
                        }
                    }
                },
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-color": "#3887be",
                    //"line-width": 5,
                    'line-width': {
                        base: 2,
                        stops: [[12, 3], [22, 12]]
                    },
                    "line-opacity": 0.75
                }
            });
        };
    };

    map.on('load', function () {
        updateRouteSource([]);

    });

    $(".distance-item-geo").click(function () {
        var lat = parseFloat($(this).attr("data-latitude"));
        var lng = parseFloat($(this).attr("data-longitude"));
        var poiCoords = [lng, lat];
        var poiLngLat = new mapboxgl.LngLat(lng, lat);
        var poiTitle = $(this).html();
        var myTravelMode = $(this).attr("data-travelmode").toLowerCase();
        //console.log("myTravelMode: " + myTravelMode);
        //getRoute(poiCoords, myTravelMode);

        if (poiMarker) {
            poiMarker.remove();
            poiMarker = null;
        }
        var poiContent = "<div style='width:200px'>" + poiTitle + "</div>"
        //poiMarker = createMarker(poiLngLat, "@Html.AssetImgUrl("googlekort_marker.png", true)", poiContent);
        poiMarker = createMarker(poiLngLat, "", poiContent);
        if (poiMarker) {
            var bounds = new mapboxgl.LngLatBounds();
            bounds.extend(myLngLat);
            bounds.extend(poiLngLat);
            var padding = 12;
            var paddingX = markerWidth / 2 + padding;
            map.fitBounds(bounds, {
                padding: { top: markerHeight + padding, bottom: padding, left: paddingX, right: paddingX }
            });

            poiMarker.togglePopup();
            setTimeout(function () {
                getRoute(poiCoords, myTravelMode);
            }, 250);
        }

        // scroll to map?
        var elementTop = $("#map_canvas_hotel_hotel").offset().top;
        var viewportTop = $(window).scrollTop();

        //console.log("elementTop: " + elementTop + "viewportTop: " + viewportTop);
        if (elementTop < viewportTop) {
            // get top menu height
            var scrollOffset = -56;
            if ($(".sticky-wrapper.is-sticky").length == 1) {
                scrollOffset = ($(".sticky-wrapper.is-sticky").height() * -1) + 1;
            }
            pageScrollTo("#map_canvas_hotel_hotel", scrollOffset);
        }

    });
}

AppLoader.ready(async function () {
    if (hasMapDependencies) {
        let init_map = async function () {
            let components = await getComponents();
            mapboxgl = components.mapboxgl;
            mapboxSdk = components.mapboxSdk;
            mapboxDirections = components.mapboxDirections;
            CreateMap = components.CreateMap;
            InitMapboxStyleSwitch = components.InitMapboxStyleSwitch;

            initialize();
            initializeDirections();

            return true;
        }
        
        let mapElement = document.querySelector('#map_canvas_hotel_hotel');
        let lazyInitializer = new LazyInitializer(mapElement, init_map);
        //lazyInitializer.init().then((result) => {
        //    console.log('>>> lazyInitializer >> Initialize Map and Directions done', result);
        //});
        lazyInitializer.init();
    }
});

//AppLoader.setReady();
